import React, { useState, useEffect } from "react";
import { Stack, Container } from "@mui/material";
import Api from "../../network/Api";
import Typewriter from 'typewriter-effect';
import SendButton from "../Conversations/SendButton";

const NewLesson = (props: { onConversationCreate: (conversationId: string, prompt: string) => void }) => {

  const [prompt, setPrompt] = useState<string>("");
  const [isAsking, shouldAsk] = useState<boolean>(false);

  useEffect(() => {
    if (!isAsking) { return }
    Api.post("/conversations", {}).then(result => {
      props.onConversationCreate(result.id, prompt)
    });
  }, [isAsking]);

  return (
    <Stack
      className="animate__animated animate__fadeIn"
      marginY="auto"
      width="100%"
    >
      <Container maxWidth="md">

        <h2 className='animate__animated animate__fadeInDown'>Describe a specific problem or lesson learned</h2>
        <h3 className="text-light text-info" style={{marginBottom: "2rem"}}>
          e.g. <Typewriter
            options={{
              strings: [
                'our apps is crashing too many times',
                '...',
              ],
              autoStart: true,
              loop: true,
              delay: 0.5
            }}
          />
        </h3>

        <SendButton value={prompt}
                    disabled={isAsking}
                    onChange={setPrompt}
                    onClick={() => shouldAsk(true)} />
        
      </Container>
    </Stack>
  );
};

export default NewLesson;
